import type { PersonaNavConfig } from './types';

export const navManager: PersonaNavConfig = {
  persona: 'manager',
  groups: [
    {
      key: 'top',
      items: [
        {
          key: 'team-dashboard',
          label: 'Mon équipe',
          route: '/team',
          icon: 'Users',
          permission: { module: 'hr', feature: 'employee-read' },
        },
      ],
    },
    {
      key: 'validations',
      label: 'Validations',
      items: [
        {
          key: 'team-timesheets',
          label: 'Relevés à valider',
          route: '/team/timesheets',
          icon: 'Clock',
          matchStartsWith: '/team/timesheets',
          badgeSource: 'pending-timesheets',
          permission: { module: 'hr', feature: 'timesheet-read' },
        },
        {
          key: 'team-leave',
          label: 'Congés',
          route: '/team/leave',
          icon: 'CalendarDays',
          matchStartsWith: '/team/leave',
          permission: { module: 'leave_mgmt', feature: 'leave-approve' },
          moduleAvailable: 'leave_mgmt',
        },
        {
          key: 'team-expenses',
          label: 'Notes de frais',
          route: '/team/expenses',
          icon: 'Wallet',
          matchStartsWith: '/team/expenses',
          permission: { module: 'expenses', feature: 'expense-approve' },
          moduleAvailable: 'expenses',
        },
      ],
    },
    {
      key: 'interim',
      label: 'Intérim',
      tenantType: 'interim',
      items: [
        {
          key: 'team-missions',
          label: 'Missions',
          route: '/team/missions',
          icon: 'Briefcase',
          matchStartsWith: '/team/missions',
          moduleAvailable: 'interim',
        },
        {
          key: 'team-clients',
          label: 'Clients',
          route: '/team/clients',
          icon: 'Building2',
          matchStartsWith: '/team/clients',
          moduleAvailable: 'interim',
        },
      ],
    },
    {
      key: 'bottom',
      items: [
        {
          key: 'inbox',
          label: 'Boîte de tâches',
          route: '/inbox',
          icon: 'Inbox',
          badgeSource: 'inbox',
        },
      ],
    },
  ],
};
